<template>
  <div>
    <v-card class="mt-3 pa-3 rounded_max" elevation="1">
      <v-row no-gutters>
        <v-col cols="12">
          <div class="pa-2 d-flex align-center">
            <v-icon class="mr-2">mdi-link</v-icon>
            <h4>Meeting Link</h4>
          </div>
        </v-col>
        <v-col cols="12">
          <div class="pa-3">
            <v-textarea
              hide-details
              class="mx-2"
              placeholder="Put the link here"
              rows="3"
              outlined
              v-model="link"
              auto-grow
              append-outer-icon="mdi-open-in-new"
              @click:append-outer="openUrl"
            ></v-textarea>
          </div>
        </v-col>
        <v-col cols="12">
          <div class="pa-2 d-flex align-center">
            <v-icon class="mr-2">mdi-calendar-month-outline</v-icon>
            <h4>Start Meeting</h4>
          </div>
        </v-col>
        <v-col cols="12">
          <div class="pa-3">
            <v-row no-gutters>
              <v-col cols="12" md="7">
                <div class="pa-2">
                  <p class="default_txt">Start Date</p>
                  <v-menu
                    v-model="calendar"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="start_date"
                        placeholder="Click here"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        hide-details
                        dense
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="start_date"
                      @input="calendar = false"
                      :min="$date().format('YYYY-MM-DD')"
                    ></v-date-picker>
                  </v-menu>
                </div>
              </v-col>

              <v-col cols="12" md="5">
                <div class="pa-2">
                  <p class="default_txt">Start Time</p>
                  <v-menu
                    ref="menu1"
                    v-model="time"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="start_time"
                        placeholder="Click Here"
                        append-icon="mdi-clock-time-four-outline"
                        readonly
                        v-bind="attrs"
                        dense
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="time"
                      v-model="start_time"
                      full-width
                      @click:minute="$refs.menu1.save(start_time)"
                    ></v-time-picker>
                  </v-menu>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
      <v-overlay :absolute="true" color="white" opacity="1" :value="loading">
        <v-progress-circular
          indeterminate
          class="mr-2"
          color="#006341"
        ></v-progress-circular>
        <b class="color_default">Loading...</b>
      </v-overlay>

      <div
        class="d-flex justify-end mt-4"
        v-if="link && start_date && start_time"
      >
        <v-btn
          v-if="!loading"
          class="text-capitalize rounded-lg mr-3"
          outlined
          dark
          :color="color"
          @click="
            link = '';
            start_date = '';
            start_time = '';
          "
          >Cancel</v-btn
        >
        <v-btn
          v-if="!loading"
          class="text-capitalize rounded-lg px-5"
          depressed
          dark
          :color="color"
          @click="assignSynchronous"
          >Save</v-btn
        >
        <v-btn
          v-if="loading"
          :class="` text-capitalize rounded-lg`"
          depressed
          dark
          :color="color"
          >Saving</v-btn
        >
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  components: {},
  name: "formSynchronous",
  data() {
    return {
      d_create: false,
      d_large: false,
      d_type: "",
      d_title: "",
      selectedData: null,
      inventory: null,
      loading: false,
      loadingGb: false,
      dataSet: null,
      getAway: false,
      loading: false,
      err: "",
      link: "",
      calendar: false,
      start_date: "",
      time: false,
      start_time: "",
    };
  },
  props: ["color", "module"],
  mounted() {},
  methods: {
    openUrl() {
      window.open(this.link, "_blank");
    },
    assignSynchronous() {
      this.loading = true;
      this.err = "";
      let body = {
        course_synchronous_id: this.module.id,
        title: this.module.title,
        description: this.module.description,
        content: this.link,
        session_date: this.start_date,
        session_time: this.start_time,
      };
      let data = {
        path: `manage/course/section/synchronus/update/detail`,
        body: body,
      };
      this.$store
        .dispatch("user/postApi", data)
        .then((data) => {
          this.$emit("refetch", true);
          this.title = "";
          this.description = "";
          this.link = "";
          this.start_date = "";
          this.start_time = "";
          this.loading = false;
        })
        .catch((err) => {
          this.$store.dispatch("notify", {
            msg: err.message,
            type: "error",
          });
          this.loading = false;
        });
    },
  },
};
</script>
<style scoped>
.strip {
  padding: 3px;
  width: 10px;
  max-height: 100%;
  border-radius: 0 !important;
}
</style>
